import { REHYDRATE } from "redux-persist/constants";
import omit from "lodash/omit";
import actiontypes from "../actiontypes";

const initialState = {
  logging_in: false,
  login_failed: false,
  token: "",
  user: {},
  loading_users: false,
  load_users_failed: false,

  loading_user: false,
  load_user_failed: false,

  saving_user: false,
  saved_user: false,
  save_user_failed: false,
  save_user_errors: {},

  requesting_password: false,
  requested_password: false,

  resetting_password: false,
  password_reset: false,
  reset_password_failed: false,

  validating_registration: false,
  validated_registration: false,
  registration_validation_failed: false,

  users: [],
  edit_user: {}
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE: {
      const incoming = action.payload.auth;
      if (incoming) {
        return { ...state, ...omit(incoming, "user") };
      }
      return state;
    }
    case actiontypes.LOGGING_IN:
      return {
        ...initialState,
        logging_in: true
      };
    case actiontypes.LOGIN_FAILED:
      return {
        ...initialState,
        login_failed: true
      };
    case actiontypes.REQUESTING_PASSWORD:
      return {
        ...state,
        requesting_password: true,
        requested_password: false
      };
    case actiontypes.RESET_REQUEST_PASSWORD:
      return {
        ...state,
        requesting_password: false,
        requested_password: false
      };
    case actiontypes.REQUESTED_PASSWORD:
      return {
        ...state,
        requesting_password: false,
        requested_password: true
      };
    case actiontypes.RESET_RESET_PASSWORD:
      return {
        ...state,
        resetting_password: false,
        password_reset: false,
        reset_password_failed: false
      };
    case actiontypes.RESETTING_PASSWORD:
      return {
        ...state,
        resetting_password: true,
        password_reset: false,
        reset_password_failed: false
      };
    case actiontypes.PASSWORD_RESET:
      return {
        ...state,
        resetting_password: false,
        password_reset: true,
        reset_password_failed: false
      };
    case actiontypes.RESET_PASSWORD_FAILED:
      return {
        ...state,
        resetting_password: false,
        password_reset: false,
        reset_password_failed: true
      };
    case actiontypes.FETCHING_USERS:
      return {
        ...state,
        loading_users: true
      };
    case actiontypes.FETCHED_USERS:
      return {
        ...state,
        loading_users: false,
        users: action.payload
      };
    case actiontypes.FETCH_USERS_FAILED:
      return {
        ...state,
        loading_users: false,
        load_users_failed: true
      };
    case actiontypes.FETCHING_USER:
      return {
        ...state,
        loading_user: true
      };
    case actiontypes.FETCHED_USER:
      return {
        ...state,
        loading_user: false,
        user: action.payload
      };
    case actiontypes.FETCH_USER_FAILED:
      return {
        ...state,
        loading_user: false,
        load_user_failed: true
      };
    case actiontypes.LOGGED_IN:
      return {
        ...state,
        logging_in: false,
        login_failed: false,
        token: action.payload.token,
        user: action.payload.user
      };
    case actiontypes.LOGOUT:
      return initialState;

    case actiontypes.SAVING_USER: {
      return {
        ...state,
        saving_user: true,
        saved_user: false,
        save_user_failed: false,
        save_user_errors: {}
      };
    }

    case actiontypes.SAVED_USER: {
      return {
        ...state,
        user: { ...state.user, ...action.payload.body },
        saving_user: false,
        saved_user: true,
        save_user_failed: false,
        save_user_errors: {}
      };
    }
    case actiontypes.SAVE_USER_FAILED: {
      return {
        ...state,
        saving_user: false,
        saved_user: false,
        save_user_failed: true,
        save_user_errors: action.payload.field_errors
      };
    }

    case actiontypes.CLEAR_EDIT_USER: {
      return {
        ...state,
        edit_user: {},
        saving_user: false,
        saved_user: false,
        save_user_failed: false,
        save_user_errors: {}
      };
    }

    case actiontypes.VALIDATING_REGISTRATION: {
      return {
        ...state,
        validating_registration: true,
        validated_registration: false,
        registration_validation_failed: false
      };
    }

    case actiontypes.VALIDATED_REGISTRATION: {
      return {
        ...state,
        validating_registration: false,
        validated_registration: true,
        registration_validation_failed: false,
        user: action.payload.user,
        token: action.payload.token
      };
    }

    case actiontypes.VALIDATE_REGISTRATION_FAILED: {
      return {
        ...state,
        validating_registration: false,
        validated_registration: false,
        registration_validation_failed: true
      };
    }

    default:
      return state;
  }
};

export default authReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/auth.js
 **/